import type { Language } from "@/models/language";
import { QuestionnaireLanguage } from "@/models/enum/questionnaireLanguage";

export const Languages: Language[] = [
  { id: QuestionnaireLanguage.En, text: "English" },
  { id: QuestionnaireLanguage.No, text: "Norwegian" },
];
